export const colors = {
  orange: '#feac31',
  darkGray: '#181818',
  midGray: '#282828',
  lightGray: '#a0a0a0',
  white: '#fff',
  black: '#000',
  green: '#09943a',
  lightGreen: '#1db954'
};